export default "__VITE_ASSET__DkSTpF1k__"